/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_Encryption_Key_MissingInputs */

const vi_einvoice_settings_encryption_key_missing = /** @type {(inputs: Einvoice_Settings_Encryption_Key_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform chưa cấu hình khoá mã hoá. Vui lòng liên hệ quản trị viên.`)
};

/**

* @param {Einvoice_Settings_Encryption_Key_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_encryption_key_missing = /** @type {((inputs?: Einvoice_Settings_Encryption_Key_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_Encryption_Key_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_encryption_key_missing(inputs)
});